import React from 'react';
import {
  Card,
  CardContent,
  CardMedia,
  Chip,
  Typography,
  Box,
  useMediaQuery,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { env } from '../../../../../../env';
import OverflowTitle from '../../../../../../components/OverflowTitle';

import { ISelectEventItemView } from './interfaces';

import { useStyles } from './styles';

const SelectEventItemView = ({
  event,
  eventsCount,
  onClick,
}: ISelectEventItemView) => {
  const classes = useStyles();
  const isMobile = useMediaQuery('(max-width:900px)');

  const showGameliftStreamsInfo = false;

  let inUseCapacity = 0;
  let alwaysOnAvailable = 0;
  let totalIdleCapacity = 0;
  let totalAlwaysOnCapacity = 0;
  let totalOnDemandCapacity = 0;

  if (showGameliftStreamsInfo) {
    const calculateTotalCapacity = () => {
      if (!event?.streamGroupConfig?.LocationStates)
        return {
          idle: 0,
          alwaysOn: 0,
          onDemand: 0,
          allocated: 0,
        };

      return event.streamGroupConfig.LocationStates.reduce(
        (acc, state) => ({
          idle: acc.idle + (state.IdleCapacity || 0),
          alwaysOn: acc.alwaysOn + (state.AlwaysOnCapacity || 0),
          onDemand: acc.onDemand + (state.OnDemandCapacity || 0),
          allocated: acc.allocated + (state.AllocatedCapacity || 0),
        }),
        {
          idle: 0,
          alwaysOn: 0,
          onDemand: 0,
          allocated: 0,
        },
      );
    };

    const {
      idle,
      alwaysOn,
      onDemand,
      allocated: totalAllocatedCapacity,
    } = calculateTotalCapacity();

    totalIdleCapacity = idle;
    totalAlwaysOnCapacity = alwaysOn;
    totalOnDemandCapacity = onDemand;
    inUseCapacity = totalAllocatedCapacity - totalIdleCapacity;
    alwaysOnAvailable = totalAlwaysOnCapacity - inUseCapacity;
  }

  return (
    <Box sx={classes.container}>
      {isMobile && eventsCount > 1 && (
        <Box sx={classes.mobileContainer}>
          <ArrowBackIcon sx={classes.icon} />
          <Typography variant="body2" sx={classes.swipeText}>
            Swipe to see more events
          </Typography>
          <ArrowForwardIcon sx={classes.icon} />
        </Box>
      )}

      <Card sx={classes.root} onClick={onClick}>
        {showGameliftStreamsInfo && event.streamGroupConfig ? (
          <Chip
            label={
              <>
                <Typography sx={{ textAlign: 'left' }}>
                  Reserved:{' '}
                  {alwaysOnAvailable > 0
                    ? `${Math.max(0, alwaysOnAvailable)} /
                  ${totalAlwaysOnCapacity}`
                    : '0'}
                </Typography>
                {totalOnDemandCapacity > 0 && (
                  <Typography sx={{ textAlign: 'left' }}>
                    On-demand: {totalOnDemandCapacity >= 0 ? 'On' : 'Off'}
                  </Typography>
                )}
              </>
            }
            className="capacity-info"
            size={'medium'}
            sx={classes.chipCapacity}
          />
        ) : null}
        {event.clientChangeset ? (
          <Chip
            label={`Version: ${event.clientChangeset}`}
            size="small"
            sx={classes.version}
          />
        ) : null}
        <CardMedia
          component="img"
          image={event.logoImage ? event.logoImage.url : ''}
          alt=""
          sx={classes.image}
        />
        <CardContent sx={classes.content}>
          <OverflowTitle
            title={event.name}
            component="div"
            sx={classes.eventName}
          />
        </CardContent>
      </Card>
    </Box>
  );
};

export default SelectEventItemView;
